import React, { useState, useEffect } from "react";
import FooterLogo from "../assets/images/header-logo.svg";
import heart from "../assets/images/heart.svg";
import footerlogo from "../assets/images/footer_logo.png";
import callicon from "../assets/images/call-icon.svg";
import facebook from "../assets/images/facebook.svg";
import instagram from "../assets/images/instagram.svg";
import Snapchat from "../assets/images/Snapchat.svg";
import iconcalendar from "../assets/images/icon-calendar.svg";
import ordericon from "../assets/images/order_icon.svg";
import tiktokblack from "../assets/images/tiktok-black.svg";
import xcode from "../assets/images/xcode.svg";
import { config } from "../config";
import { useLocation } from "react-router";
// import iconloction from "../../assets/images/icon-location.svg";
import iconloction from "../assets/images/icon-location.svg";
import Cookies from "js-cookie";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import setting_icon from "../assets/images/setting_icon.svg";

function Footer() {
  const [isShow, setIsShow] = useState(!Cookies.get("cookiesAccepted"));
  const [activeButton, setActiveButton] = useState("Accept");
  const [isAtBottom, setIsAtBottom] = useState();
  useEffect(() => {
    const handleScroll = () => {
      const isBottom =
        window.innerHeight + window.scrollY + 10 >= document.body.scrollHeight;
      setIsAtBottom(isBottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [configData, setConfigData] = useState(
    JSON.parse(localStorage.getItem("configData"))
  );
  const location = useLocation();
  const hiddenFooter = ["/checkout", "/payment", "/cart"];

  if (hiddenFooter.includes(location.pathname)) return null;

  const home = localStorage.getItem("home")
    ? JSON.parse(localStorage.getItem("home"))
    : null;
  const currentYear = new Date().getFullYear();
  // window.onscroll = () => {
  //   const isAtBottom =
  //     window.innerHeight + window.scrollY + 10 >= document.body.offsetHeight;

  //   setIsAtBottom(isAtBottom);
  // };
  const isFromAppView =
    localStorage.getItem("isAppView") != "isAppView"
      ? JSON.parse(localStorage.getItem("isAppView"))
      : null;
  return (
    <>
      <div
        className={`${location.pathname === "/account" ? "account-footer" : ""}
           ${location.pathname.includes("store") ? "store-footer" : ""}
           ${location.pathname == "/menu" ? "menu-footer" : ""}
           ${location.pathname == "/cart" ? "cart-footer" : ""}
         ${isFromAppView ? "app-footer" : ""} footer`}
        style={{ marginBottom: location.pathname === "/" ? "0px" : "0px" }}
      >
        {location.pathname !== "/" && (
          <div className="footer-top">
            <div className="container">
              <div className="row justify-content-center align-items-center">
                <div className="col-lg-3">
                  <div className="footer-logo">
                    <a href="/">
                      <img
                        src={
                          configData
                            ? `${config.localApiUrl}/tenancy/assets/${configData.footerLogo}`
                            : FooterLogo
                        }
                        alt=""
                      />
                    </a>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="footer-text">
                    <ul>
                      <li>
                        <a href={`tel:${configData.contactNumber}`}>
                          <img src={callicon} />
                          {configData.contactNumber}
                        </a>
                      </li>
                      {configData &&
                        configData.locationData &&
                        configData.locationData.addressLine1 && (
                          <li>
                            <a
                              href={
                                configData &&
                                configData.locationData.directionLink
                              }
                              target="_blank"
                            >
                              <img src={iconloction} />
                              {configData.locationData.addressLine1}{" "}
                              {configData.locationData.addressLine2}
                            </a>
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="footer-icon">
                    <ul>
                      {configData &&
                        configData.socialData.tiktokUrl &&
                        configData.socialData.tiktokUrl != "null" && (
                          <li>
                            <a href={configData.socialData.tiktokUrl}>
                              <div className="tiktok-icon" />
                            </a>
                          </li>
                        )}
                      {configData &&
                        configData.socialData.facebookUrl &&
                        configData.socialData.facebookUrl != "null" && (
                          <li>
                            <a href={configData.socialData.facebookUrl}>
                              <div className="fb-icon" />
                            </a>
                          </li>
                        )}
                      {configData &&
                        configData.socialData.instagramUrl &&
                        configData.socialData.instagramUrl != "null" && (
                          <li>
                            <a href={configData.socialData.instagramUrl}>
                              <div className="insta-icon" />
                            </a>
                          </li>
                        )}
                      {configData && configData.socialData.snapchatUrl &&
                        configData.socialData.tiktokUrl != "null" && (
                          <li>
                            <a href={configData.socialData.snapchatUrl}>
                              <div className="snap-icon" />
                            </a>
                          </li>
                        )}
                      {configData && configData.socialData.twitterUrl &&
                        configData.socialData.twitterUrl != "null" && (
                          <li>
                            <a href={configData.socialData.twitterUrl}>
                              <div className="x-code" />
                            </a>
                          </li>
                        )}

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className={`footer-bottom 
            ${location.pathname === "/" && isAtBottom ? "yo_sushi" : ""} 
            ${/reservation/i.test(location.pathname)
              ? "reservation-form-footer"
              : ""
            }
            `}
          style={{
            marginBottom:
              location.pathname === "/" && isAtBottom ? "0px" : "0px",
            transition: "margin-bottom 0.75s ease",
          }}
        >
          <div className="container">
            <div className="copy-right-inner">
              <em>
                <p className="copy-right-text">
                  <span>©</span>
                  {currentYear}. {configData && configData.websiteName}. All
                  rights reserved.
                </p>
              </em>
              {location.pathname !== "/" && (
                <ul>
                  <li>
                    <a href="/">Terms of Service</a>
                  </li>
                  <li>
                    <a href="/">Privacy</a>
                  </li>
                </ul>
              )}
              <p className="loyalty-text">
                made with
                <em>
                  <img src={heart} alt="heart icon" />
                </em>
                by
                <a
                  href="https://sumoordering.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={footerlogo} alt="" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={isShow}
        onHide={() => setIsShow(false)}
        size="lg"
        className="cookies-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="cookies-modal-show">
            <div className="container">
              <div className="text-content">
                <h2>We use cookies</h2>
                <p>
                  Click Accept to allow SumoEats to use cookies to personalise
                  this site, and to deliver ads and measure their effectiveness
                  on other apps and websites, including social media. Customise
                  your preferences in your cookie settings or click Reject if
                  you do not want us to use cookies for this purpose. Learn more
                  in
                </p>
                <Link to="/CookiePolicy">our Cookie Notice.</Link>
              </div>
              <div className="cookies-setting">
                <span>
                  <img src={setting_icon} alt="" />
                </span>
                <p>Cookie settings</p>
              </div>
              <div className="group-btn">
                <button
                  title="Reject"
                  className={`primary-btn sm Back ${activeButton === "Reject" ? "active" : ""
                    }`}
                  onClick={() => {
                    Cookies.remove("cookiesAccepted");
                    setIsShow(false);
                    setActiveButton("Reject");
                  }}
                >
                  Reject
                </button>
                <button
                  title="Accept"
                  className={`primary-btn sm Continue ${activeButton === "Accept" ? "active" : ""
                    }`}
                  onClick={() => {
                    Cookies.set("cookiesAccepted", "true", { expires: 365 }); // Cookie expires in 1 year
                    setActiveButton("Accept");
                    setIsShow(false);
                  }}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Footer;
